import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import moment from 'moment';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import auth from "../../../auth";

import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import PasswordPolicyHint from "../../../components/PasswordPolicyHint/PasswordPolicyHint.js"
import { SpriteSesiones, LogoNavegador } from "../../../components/IconosSesiones/IconosSesiones.js"

import { validatePassword } from "../../../functions/passwordPolicy";


import { Button, Col, Nav, NavItem, NavLink, Row, Table, TabContent, TabPane } from 'reactstrap';

// Ids de las pestañas. Numericos como en views/Usuarios/Usuarios/Modal.js, que
// es el otro modal con tabs del proyecto.
const TAB_PERFIL = 1;
const TAB_SESIONES = 2;
const TAB_AUTENTICADOR = 3;

// En que paso esta la pestaña Autenticador. null es el estado de reposo, donde
// solo se muestra si hay un autenticador registrado o no.
//
//   PASO_PASSWORD_REGISTRAR  pidiendo la contraseña para arrancar un registro
//   PASO_ESCANEAR            mostrando el QR y esperando el primer codigo
//   PASO_PASSWORD_QUITAR     pidiendo la contraseña para quitar el que hay
//
// Es un solo campo y no tres booleanos porque los tres pasos son mutuamente
// excluyentes: con booleanos separados existe el estado "pidiendo la contraseña
// para registrar y para quitar a la vez", que no significa nada.
const PASO_PASSWORD_REGISTRAR = 'password_registrar';
const PASO_ESCANEAR = 'escanear';
const PASO_PASSWORD_QUITAR = 'password_quitar';

// El logo de navegador de la columna Dispositivo sale de un sprite SVG propio,
// no de font-awesome: el por que esta en el componente.


class Perfil extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: TAB_PERFIL,
            last_name: "",
            first_name: "",
            username: "",
            email: "",
            passwordActual: "",
            password: "",
            password2: "",
            errors: {},
            // Estado del guardado de ESTA pestaña. El modal ya no tiene footer:
            // cada pestaña se guarda sola (ver el comentario del render).
            guardandoPerfil: false,
            guardadoOk: false,
            errorPerfil: null,

            sesiones: [],
            cargandoSesiones: false,
            errorSesiones: null,
            // Id de la sesion que esta esperando confirmacion para cerrarse, o
            // null si ninguna. Es de a una: pedir confirmacion en otra fila
            // cancela la anterior.
            sesionAConfirmar: null,

            // Pestaña Autenticador. `estadoAutenticador` es lo que contesta
            // GET usuarios/perfil/autenticador/ ({activo, registroPendiente,
            // confirmado}) y queda en null mientras no se cargo.
            estadoAutenticador: null,
            cargandoAutenticador: false,
            errorAutenticador: null,
            pasoAutenticador: null,
            // La contraseña con la que se confirma que es el usuario el que hace
            // esto, y el codigo del autenticador. Dos campos distintos del
            // `password` de la pestaña Perfil a proposito: ahi se escribe una
            // contraseña NUEVA y aca la actual, y compartir el estado haria que
            // escribir en una pestaña modifique la otra.
            passwordAutenticador: "",
            codigoAutenticador: "",
            // { qr, uri, secreto } del registro en curso. El secreto solo existe
            // en esta respuesta y en este estado: no se puede volver a pedir.
            registroAutenticador: null,
        };
    }

    static propTypes = {
        onOpen: PropTypes.func,
        onClose: PropTypes.func,
    }

    resetForm() {
        this.setState({
            errors: {},

            // Vuelve a la primera pestaña al reabrir, igual que Modal.js.
            activeTab: TAB_PERFIL,

            last_name: "",
            first_name: "",
            username: "",
            email: "",
            passwordActual: "",
            password: "",
            password2: "",

            guardandoPerfil: false,
            guardadoOk: false,
            errorPerfil: null,

            sesiones: [],
            errorSesiones: null,
            sesionAConfirmar: null,

            // El secreto y el QR se descartan al cerrar el modal: si el usuario
            // no llego a confirmar, reabrir tiene que arrancar un registro
            // nuevo y no mostrar el QR de antes. El backend acompaña — cada
            // POST de alta genera un secreto nuevo y pisa el anterior.
            estadoAutenticador: null,
            errorAutenticador: null,
            pasoAutenticador: null,
            passwordAutenticador: "",
            codigoAutenticador: "",
            registroAutenticador: null,
        });
    }

    /**
     * Valida la pestaña Perfil antes de mandarla. Devuelve si esta para guardar.
     *
     * Lo que valida el cliente es solo lo que el cliente puede saber: que las
     * dos contraseñas nuevas coincidan, que cumplan la politica, y que no falte
     * la actual. El backend revalida todo y ademas chequea lo unico que no se
     * puede chequear aca — que la contraseña actual sea la correcta.
     */
    validate() {
        const { passwordActual, password, password2 } = this.state;

        // Los tres campos vacios significan "no cambiar la contraseña"; getData()
        // tampoco la manda en el PATCH, asi que no hay nada que validar.
        if (password.length == 0 && password2.length == 0) return true;

        let errors = {};

        const passwordErrors = validatePassword(password);
        if (passwordErrors.length > 0) errors['password'] = passwordErrors;

        if (password != password2) {
            errors['password2'] = [{
                code: "invalid",
                detail: "Las contraseñas deben ser iguales"
            }];
        }

        if (passwordActual.length == 0) {
            errors['password_actual'] = [{
                code: "invalid",
                detail: "Escriba su contraseña actual para poder cambiarla"
            }];
        }

        if (Object.keys(errors).length == 0) return true;

        this.setState(prevState => ({
            errors: { ...prevState.errors, ...errors }
        }));
        return false;
    }

    /**
     * El cuerpo del PATCH de la pestaña Perfil.
     *
     * La contraseña (y con ella la actual) solo viajan si se escribio una nueva:
     * los campos vacios significan "no cambiarla", y mandar password_actual
     * sin password haria que el backend valide una contraseña para nada.
     */
    getData() {
        const { last_name, first_name, passwordActual, password } = this.state;

        let data = {
            last_name: last_name,
            first_name: first_name,
        };

        if (password.length > 0) {
            data.password = password;
            data.password_actual = passwordActual;
        }

        return data;
    }

    /**
     * Guarda la pestaña Perfil. Es el boton que vive adentro de la pestaña.
     *
     * Va con axios directo y no por el submit del ParadigmaModal porque ese
     * submit era del MODAL entero: con el footer puesto, el boton Guardar
     * seguia ahi estando parado en Sesiones o en Autenticador, donde no guarda
     * nada de lo que se esta mirando. Ahora cada pestaña se ocupa de lo suyo,
     * que es como ya funcionaban Sesiones y Autenticador.
     *
     * El modal NO se cierra al guardar: antes lo hacia, pero ahora que el boton
     * vive adentro de una pestaña, cerrar todo el modal al tocarlo seria una
     * consecuencia desproporcionada — sobre todo si la persona entro para mirar
     * sus sesiones y de paso corrigio el nombre.
     */
    guardarPerfil() {
        if (!this.validate()) return;

        this.setState({ guardandoPerfil: true, guardadoOk: false, errorPerfil: null });

        axios.patch(api.usuarios.perfil, this.getData(), auth.header())
            .then(() => {
                this.setState({
                    guardandoPerfil: false,
                    guardadoOk: true,
                    errors: {},
                    // Los campos de contraseña se vacian: ya se aplico el
                    // cambio, y dejarlos cargados invita a guardar de nuevo.
                    passwordActual: "",
                    password: "",
                    password2: "",
                });
            })
            .catch((e) => {
                const cuerpo = (e && e.response && e.response.data) || {};
                const errors = cuerpo.errors || {};
                const meta = cuerpo.meta || {};

                this.setState({
                    guardandoPerfil: false,
                    guardadoOk: false,
                    // Los errores por campo vienen con la forma que esperan los
                    // ParadigmaLabeledInput ({campo: [{code, detail}]}), que es
                    // la que arma ParseValidationErrors en el backend.
                    errors: (typeof errors === 'object' && !Array.isArray(errors)) ? errors : {},
                    // Y el mensaje suelto, para lo que no cuelga de un campo:
                    // el 429 del bloqueo por IP, o un error inesperado.
                    errorPerfil:
                        (typeof errors.error === 'string' && errors.error) ||
                        meta.message ||
                        (Object.keys(errors).length === 0
                            ? "No se pudieron guardar los cambios."
                            : null),
                });
            });
    }

    setData(data) {
        this.setState({
            last_name: data.last_name,
            first_name: data.first_name,
            username: data.username,
            email: data.email,
        });
        // Se engancha aca y no en onVisible porque el ParadigmaModal del
        // frontend-cliente no tiene ese callback, y los dos Perfil.js tienen que
        // seguir siendo el mismo archivo.
        this.traerSesiones();
        this.traerEstadoAutenticador();
    }

    /**
     * Las sesiones abiertas del usuario.
     *
     * Va con axios directo y no con apifunctions porque la firma de
     * apifunctions.delete difiere entre los dos frontends (el de admin lleva un
     * parametro `data` que el del cliente no tiene), y este archivo tiene que
     * poder copiarse tal cual entre los dos.
     */
    traerSesiones() {
        this.setState({ cargandoSesiones: true, errorSesiones: null });
        axios.get(api.usuarios.perfilSesiones, auth.header()).then((response) => {
            this.setState({
                sesiones: response.data.data || [],
                cargandoSesiones: false,
            });
        }).catch(() => {
            this.setState({
                sesiones: [],
                cargandoSesiones: false,
                errorSesiones: "No se pudieron cargar las sesiones.",
            });
        });
    }

    /**
     * Primer click en Cerrar: pide confirmacion en la misma fila.
     *
     * Por que en la fila y no en un modal, que es como confirma el resto del
     * sistema: este componente YA vive adentro de un ParadigmaModal, y anidar
     * modales de reactstrap pelea por el foco y por el backdrop. Preguntando en
     * la fila tampoco hace falta repetir de que sesion se trata, que es lo
     * primero que un modal tendria que aclarar.
     *
     * Ojo que esto NO afecta al "Cerrar sesión" del menu del usuario: ese cierra
     * la sesion propia, no pasa por aca y sigue siendo de un solo click.
     */
    confirmarCierre(id) {
        this.setState({ sesionAConfirmar: id, errorSesiones: null });
    }

    cancelarCierre() {
        this.setState({ sesionAConfirmar: null });
    }

    /**
     * Cierra una sesion y recarga la lista.
     *
     * No se saca la fila del estado a mano: se vuelve a pedir el listado, asi lo
     * que se ve es lo que el backend tiene y no una suposicion del cliente.
     */
    cerrarSesion(id) {
        this.setState({
            cargandoSesiones: true,
            errorSesiones: null,
            sesionAConfirmar: null,
        });
        axios.delete(api.usuarios.perfilSesiones + id + "/", auth.header())
            .then(() => this.traerSesiones())
            .catch(() => {
                this.setState({
                    cargandoSesiones: false,
                    errorSesiones: "No se pudo cerrar la sesión.",
                });
            });
    }

    fecha(valor) {
        return valor ? moment(valor).format('DD/MM/YYYY HH:mm') : '';
    }

    /**
     * El mensaje que mando el backend, o `porDefecto`.
     *
     * Los endpoints del autenticador contestan {errors: {error: '<mensaje>'}}
     * con texto ya redactado para mostrar (la contraseña incorrecta, el codigo
     * vencido, el 429 del bloqueo por IP). Vale la pena usarlo en vez de un
     * texto generico: "Demasiados intentos fallidos, vuelva a intentar en 47
     * minutos" no se puede reconstruir del lado del cliente.
     */
    mensajeDeError(e, porDefecto) {
        const errors = (e && e.response && e.response.data && e.response.data.errors) || {};
        return typeof errors.error === 'string' ? errors.error : porDefecto;
    }

    /**
     * El estado del autenticador del usuario.
     *
     * Se pide al abrir el modal, junto con las sesiones, y se vuelve a pedir
     * despues de cada cambio: lo que se ve es lo que el backend tiene y no una
     * suposicion del cliente, igual que en la pestaña Sesiones.
     *
     * Nunca trae el secreto. Ese sale de la API una sola vez, en la respuesta
     * del alta.
     */
    traerEstadoAutenticador() {
        this.setState({ cargandoAutenticador: true, errorAutenticador: null });
        axios.get(api.usuarios.perfilAutenticador, auth.header()).then((response) => {
            this.setState({
                estadoAutenticador: response.data.data || null,
                cargandoAutenticador: false,
            });
        }).catch(() => {
            this.setState({
                estadoAutenticador: null,
                cargandoAutenticador: false,
                errorAutenticador: "No se pudo consultar el estado del autenticador.",
            });
        });
    }

    /** Abre uno de los pasos que piden algo, limpiando lo que haya tipeado antes. */
    irAPaso(paso) {
        this.setState({
            pasoAutenticador: paso,
            errorAutenticador: null,
            passwordAutenticador: "",
            codigoAutenticador: "",
        });
    }

    /**
     * Vuelve al reposo y descarta el registro en curso.
     *
     * Si habia un QR escaneado a medias, el secreto queda abandonado: el
     * backend lo tiene como registro sin confirmar, que no es un segundo factor
     * y no bloquea nada, y el proximo alta lo pisa. Por eso cancelar no necesita
     * avisarle NADA al backend.
     *
     * Pero si tiene que volver a PREGUNTARLE, y esto es lo que faltaba. Cancelar
     * un "Cambiar de dispositivo" es el caso: para llegar al QR ya se hizo el
     * POST del alta, y ese POST desactiva el autenticador que habia (ver
     * IniciarRegistro: pisa el secreto y resetea `confirmado` para no dejar dos
     * validos a la vez). O sea que al cancelar el usuario YA no tiene segundo
     * factor, pero `estadoAutenticador` seguia siendo el que se leyo al abrir el
     * modal, asi que el reposo mostraba "Tiene un autenticador registrado" sobre
     * una cuenta que habia quedado con un registro sin confirmar — y el login ya
     * no le pedia ningun codigo.
     *
     * Se vuelve a pedir siempre y no solo cuando el alta ya corrio: es la regla
     * de traerEstadoAutenticador() (lo que se muestra sale del backend, no de
     * una suposicion del cliente) y cancelar era el unico camino que la rompia.
     * Cancelar desde un paso que no toco nada del servidor paga un GET y lee lo
     * mismo que ya tenia.
     */
    cancelarAutenticador() {
        this.setState({
            pasoAutenticador: null,
            errorAutenticador: null,
            passwordAutenticador: "",
            codigoAutenticador: "",
            registroAutenticador: null,
        }, () => this.traerEstadoAutenticador());
    }

    /**
     * Paso 1 del alta: con la contraseña, pide el secreto y el QR.
     *
     * El autenticador todavia NO queda activo. Hace falta confirmarlo con un
     * codigo, que es lo que prueba que el secreto llego bien al telefono: sin
     * ese paso, un QR mal escaneado deja la cuenta inaccesible hasta que un
     * administrador revoque.
     */
    registrarAutenticador() {
        this.setState({ cargandoAutenticador: true, errorAutenticador: null });
        axios.post(
            api.usuarios.perfilAutenticador,
            { password: this.state.passwordAutenticador },
            auth.header()
        ).then((response) => {
            this.setState({
                cargandoAutenticador: false,
                registroAutenticador: response.data.data || null,
                pasoAutenticador: PASO_ESCANEAR,
                // La contraseña ya cumplio su funcion y el backend no la vuelve
                // a pedir en este flujo: no tiene por que seguir en memoria de
                // la pantalla mientras la persona busca el telefono.
                passwordAutenticador: "",
                codigoAutenticador: "",
            });
        }).catch((e) => {
            this.setState({
                cargandoAutenticador: false,
                errorAutenticador: this.mensajeDeError(
                    e, "No se pudo iniciar el registro del autenticador."
                ),
            });
        });
    }

    /** Paso 2 del alta: el primer codigo activa el autenticador. */
    confirmarAutenticador() {
        this.setState({ cargandoAutenticador: true, errorAutenticador: null });
        axios.post(
            api.usuarios.perfilAutenticadorConfirmar,
            { codigo: this.state.codigoAutenticador },
            auth.header()
        ).then(() => {
            this.setState({
                pasoAutenticador: null,
                // Se descarta el QR y el secreto en cuanto deja de hacer falta.
                registroAutenticador: null,
                codigoAutenticador: "",
            }, () => this.traerEstadoAutenticador());
        }).catch((e) => {
            this.setState({
                cargandoAutenticador: false,
                codigoAutenticador: "",
                errorAutenticador: this.mensajeDeError(
                    e, "El código es incorrecto o venció. Pruebe con el siguiente."
                ),
            });
        });
    }

    /** Saca el autenticador. Pide la contraseña, igual que el alta. */
    quitarAutenticador() {
        this.setState({ cargandoAutenticador: true, errorAutenticador: null });
        axios.post(
            api.usuarios.perfilAutenticadorQuitar,
            { password: this.state.passwordAutenticador },
            auth.header()
        ).then(() => {
            this.setState({
                pasoAutenticador: null,
                passwordAutenticador: "",
            }, () => this.traerEstadoAutenticador());
        }).catch((e) => {
            this.setState({
                cargandoAutenticador: false,
                errorAutenticador: this.mensajeDeError(
                    e, "No se pudo quitar el autenticador."
                ),
            });
        });
    }

    /**
     * El codigo tipeado, dejando solo digitos y cortado en 6.
     *
     * Los autenticadores muestran el codigo partido ('123 456') y copiarlo y
     * pegarlo arrastra el espacio: sacarlo aca es lo que hace que pegar
     * funcione. El backend tambien normaliza, asi que esto es comodidad y no la
     * validacion.
     */
    onCodigoAutenticadorChange(valor) {
        this.setState({
            codigoAutenticador: valor.replace(/\D/g, '').slice(0, 6),
            errorAutenticador: null,
        });
    }

    /**
     * La ultima celda de la fila: Cerrar, o el Si/No de la confirmacion.
     *
     * La sesion en curso no se puede cerrar desde aca: seria desloguearse a si
     * mismo desde el modal de perfil. Para eso esta Cerrar sesión del menu.
     *
     * Estos son los UNICOS botones del modal que siguen con size="sm". No es un
     * olvido: son acciones de FILA adentro de un <Table size="sm">, una por
     * sesion listada, y al tamaño normal cada fila crece y la tabla deja de
     * leerse como una tabla. Los demas botones del modal son acciones de
     * formulario y van al tamaño que tenian los del footer.
     */
    renderBotonCerrar(sesion) {
        const { cargandoSesiones, sesionAConfirmar } = this.state;

        if (sesion.actual) {
            return <span className="text-muted">Esta sesión</span>;
        }

        if (sesionAConfirmar === sesion.id) {
            return (
                <Fragment>
                    <Button
                        size="sm"
                        color="danger"
                        title="Sí, cerrar esta sesión"
                        disabled={cargandoSesiones}
                        onClick={() => this.cerrarSesion(sesion.id)}
                    >Sí</Button>{' '}
                    <Button
                        size="sm"
                        color="secondary"
                        title="No cerrarla"
                        disabled={cargandoSesiones}
                        onClick={() => this.cancelarCierre()}
                    >No</Button>
                </Fragment>
            );
        }

        return (
            <Button
                size="sm"
                color="danger"
                disabled={cargandoSesiones}
                onClick={() => this.confirmarCierre(sesion.id)}
            >Cerrar</Button>
        );
    }

    renderSesiones() {
        const { sesiones, cargandoSesiones, errorSesiones } = this.state;

        return (
            <div>
                {/* Los <symbol> del sprite. Tiene que estar montado para que los
                    logos de navegador de las filas se dibujen. */}
                <SpriteSesiones />
                <small className="text-muted d-block mb-2">
                    Si no reconoce alguna de estas sesiones, ciérrela y cambie su contraseña.
                </small>
                {errorSesiones &&
                    <div className="text-danger mb-2">{errorSesiones}</div>
                }
                <Table size="sm" className="mt-2">
                    <thead>
                        <tr>
                            <th>Dispositivo</th>
                            <th>Inicio de sesión</th>
                            <th>IP</th>
                            <th width={110}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            sesiones.map((sesion) =>
                                <tr key={sesion.id}>
                                    <td>
                                        <LogoNavegador navegador={sesion.navegador} />
                                        {sesion.dispositivo}
                                    </td>
                                    <td>{this.fecha(sesion.creado)}</td>
                                    <td>
                                        {
                                            // Null cuando ObtenerIpCliente no encontro
                                            // ninguna IP valida en el request del login.
                                            sesion.ip ||
                                            <span className="text-muted">—</span>
                                        }
                                    </td>
                                    <td>{this.renderBotonCerrar(sesion)}</td>
                                </tr>
                            )
                        }
                        {sesiones.length === 0 &&
                            <tr>
                                <td className="text-center" colSpan={4}>
                                    {cargandoSesiones ? 'Cargando...' : 'No hay sesiones abiertas'}
                                </td>
                            </tr>
                        }
                    </tbody>
                </Table>
            </div>
        );
    }

    /**
     * El campo de contraseña de los dos pasos que la piden.
     *
     * `onAceptar` y la etiqueta del boton son lo unico que cambia entre
     * registrar y quitar, asi que el formulario es el mismo. Va en un <form>
     * propio para que Enter funcione, y con onSubmit y no onClick porque el
     * ParadigmaModal que lo contiene ya tiene su propio boton de guardar: si
     * esto fuera un submit del modal, aceptar aca guardaria tambien el
     * formulario de la pestaña Perfil.
     */
    renderPasswordAutenticador(textoBoton, onAceptar) {
        const { cargandoAutenticador, passwordAutenticador } = this.state;

        return (
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    if (!cargandoAutenticador && passwordAutenticador.length > 0) onAceptar();
                }}
            >
                <Row>
                    <Col className="col-12 col-sm-6">
                        <ParadigmaLabeledInput
                            label={"Contraseña actual"}
                            type={"password"}
                            // Pisa el 'new-password' que ParadigmaLabeledInput le
                            // pone a todos los campos de password. Ese default
                            // esta bien para los demas, que son para ESCRIBIR una
                            // contraseña nueva; este es el unico del sistema que
                            // pide la ACTUAL, asi que conviene que el gestor de
                            // contraseñas pueda completarla.
                            autoComplete={"current-password"}
                            value={passwordAutenticador}
                            onChange={(e) => this.setState({
                                passwordAutenticador: e.target.value,
                                errorAutenticador: null,
                            })}
                        />
                    </Col>
                </Row>
                <div className="mt-2">
                    <Button
                        color="success"
                        disabled={cargandoAutenticador || passwordAutenticador.length === 0}
                    >{textoBoton}</Button>{' '}
                    <Button
                        color="secondary"
                        type="button"
                        disabled={cargandoAutenticador}
                        onClick={() => this.cancelarAutenticador()}
                    >Cancelar</Button>
                </div>
            </form>
        );
    }

    /**
     * El QR, el codigo para tipear a mano, y el campo del primer codigo.
     *
     * Las dos formas de cargar el secreto se muestran juntas y no una detras de
     * un "no puedo escanear": el camino manual no es una excepcion rara — es el
     * que usa cualquiera que tenga el autenticador en la misma maquina, o una PC
     * sin camara.
     */
    renderEscanearAutenticador() {
        const { registroAutenticador, cargandoAutenticador, codigoAutenticador } = this.state;

        if (!registroAutenticador) return null;

        return (
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    if (!cargandoAutenticador && codigoAutenticador.length === 6) {
                        this.confirmarAutenticador();
                    }
                }}
            >
                <Row>
                    <Col className="col-12 col-sm-5 text-center">
                        {/* El QR viene embebido como data URI en la respuesta, no
                            de una URL: codifica el secreto, asi que una URL lo
                            dejaria en el historial del browser y en los logs. */}
                        {/* El `maxWidth: '100%'` va inline y no alcanza con la
                            clase img-fluid, que es justamente lo que dice esto:
                            un estilo inline le gana en especificidad a
                            cualquier clase, asi que el `maxWidth: 220` que
                            habia aca pisaba el `max-width: 100%` de img-fluid y
                            el PNG (246px de ancho) se desbordaba de su columna y
                            se montaba encima del texto de al lado. Con los dos
                            inline, 220 es el ancho preferido y el 100% el techo
                            real contra la columna. */}
                        <img
                            src={registroAutenticador.qr}
                            alt="Código QR para la aplicación de autenticación"
                            className="img-fluid"
                            style={{ width: 220, maxWidth: '100%' }}
                        />
                    </Col>
                    <Col className="col-12 col-sm-7">
                        <small className="text-muted d-block">
                            Escanee el código con su aplicación de autenticación
                            (Authy, Google Authenticator, Microsoft Authenticator o
                            cualquier otra).
                        </small>
                        <small className="text-muted d-block mt-2">
                            Si no puede escanearlo, cargue esta clave a mano:
                        </small>
                        {/* Sin word-break: break-all. La clave ya viene en
                            grupos de 4 separados por espacios, asi que el corte
                            natural cae entre grupos; con break-all cortaba en
                            medio de uno ('7AX2 YN' / '2L'), que es exactamente
                            lo que confunde a quien la esta tipeando a mano. */}
                        <code className="d-block my-1">
                            {registroAutenticador.secreto}
                        </code>
                        <Row>
                            <Col className="col-12 col-sm-8">
                                <ParadigmaLabeledInput
                                    label={"Código de 6 dígitos"}
                                    maxLength={6}
                                    autoComplete={"one-time-code"}
                                    value={codigoAutenticador}
                                    onChange={(e) => this.onCodigoAutenticadorChange(e.target.value)}
                                />
                            </Col>
                        </Row>
                        <small className="text-muted d-block">
                            Escriba el código que muestra la aplicación para terminar.
                        </small>
                    </Col>
                </Row>
                <div className="mt-2">
                    <Button
                        color="success"
                        disabled={cargandoAutenticador || codigoAutenticador.length !== 6}
                    >Activar</Button>{' '}
                    <Button
                        color="secondary"
                        type="button"
                        disabled={cargandoAutenticador}
                        onClick={() => this.cancelarAutenticador()}
                    >Cancelar</Button>
                </div>
            </form>
        );
    }

    /** El estado de reposo: si hay autenticador o no, y el boton que corresponde. */
    renderEstadoAutenticador() {
        const { estadoAutenticador, cargandoAutenticador, errorAutenticador } = this.state;

        if (estadoAutenticador === null) {
            // El estado arranca en null y lo llena el GET que dispara setData.
            // Se decide por el error y no por `cargandoAutenticador` porque
            // entre que el modal se abre y que ese GET sale hay un instante con
            // los dos en falso, y ahi "Estado no disponible" seria mentira: el
            // unico caso en que de verdad no esta disponible es cuando el GET
            // fallo, que es justo cuando hay un error que mostrar arriba.
            return (
                <div className="text-muted">
                    {errorAutenticador ? 'Estado no disponible.' : 'Cargando...'}
                </div>
            );
        }

        if (estadoAutenticador.activo) {
            return (
                <Fragment>
                    <div className="mb-2">
                        <i className="fa fa-check-circle text-success mr-1"></i>
                        Tiene un autenticador registrado
                        {
                            estadoAutenticador.confirmado &&
                            <span className="text-muted">
                                {' '}desde el {this.fecha(estadoAutenticador.confirmado)}
                            </span>
                        }
                        .
                    </div>
                    <small className="text-muted d-block mb-2">
                        Al iniciar sesión se le va a pedir el código de 6 dígitos
                        además de la contraseña.
                    </small>
                    <Button
                        color="danger"
                        disabled={cargandoAutenticador}
                        onClick={() => this.irAPaso(PASO_PASSWORD_QUITAR)}
                    >Quitar autenticador</Button>{' '}
                    <Button
                        color="secondary"
                        disabled={cargandoAutenticador}
                        onClick={() => this.irAPaso(PASO_PASSWORD_REGISTRAR)}
                    >Cambiar de dispositivo</Button>
                </Fragment>
            );
        }

        // Registro empezado y nunca confirmado: se generó el secreto y se mostró
        // el QR, pero no se tipeó el primer código. El backend lo distingue del
        // caso "nunca registró nada" justamente para poder decirlo acá
        // (`registroPendiente` de EstadoDeUsuario).
        //
        // Avisarlo importa porque es un estado que se ve al revés de lo que es:
        // si el QR alcanzó a entrar al teléfono, la app muestra códigos de "TGS
        // Comedor" como si todo estuviera listo, mientras el sistema no tiene
        // ningún segundo factor activo y el login no pide nada. Sin este aviso
        // la pantalla decía "No tiene un autenticador registrado", que contra el
        // teléfono se lee como un error del sistema.
        if (estadoAutenticador.registroPendiente) {
            return (
                <Fragment>
                    <div className="mb-2">
                        <i className="fa fa-exclamation-triangle text-warning mr-1"></i>
                        Tiene un registro sin terminar.
                    </div>
                    <small className="text-muted d-block mb-2">
                        El autenticador <strong>no está activo</strong>: quedó a medio
                        registrar porque no se confirmó con el primer código, así que
                        al iniciar sesión no se le pide ningún código. Si le quedó una
                        cuenta de "TGS Comedor" en el teléfono, bórrela: al registrar
                        de nuevo se genera un secreto nuevo y los códigos de esa
                        cuenta ya no sirven.
                    </small>
                    <Button
                        color="success"
                        disabled={cargandoAutenticador}
                        onClick={() => this.irAPaso(PASO_PASSWORD_REGISTRAR)}
                    >Registrar autenticador</Button>
                </Fragment>
            );
        }

        return (
            <Fragment>
                <div className="mb-2">
                    <i className="fa fa-exclamation-circle text-muted mr-1"></i>
                    No tiene un autenticador registrado.
                </div>
                <small className="text-muted d-block mb-2">
                    Registrando uno, al iniciar sesión se le va a pedir un código
                    de 6 dígitos además de la contraseña.
                </small>
                <Button
                    color="success"
                    disabled={cargandoAutenticador}
                    onClick={() => this.irAPaso(PASO_PASSWORD_REGISTRAR)}
                >Registrar autenticador</Button>
            </Fragment>
        );
    }

    renderAutenticador() {
        const { pasoAutenticador, errorAutenticador, estadoAutenticador } = this.state;

        // Si ya tiene uno activo, este paso es "Cambiar de dispositivo" y no un
        // alta: el POST que viene desactiva el actual en el acto, y cancelar
        // despues no lo devuelve (IniciarRegistro genera un secreto nuevo, no
        // guarda el anterior). Conviene decirlo ANTES de pedir la contraseña —
        // es el unico momento en que la persona todavia puede echarse atras sin
        // perder nada.
        const reemplazaUnoActivo = !!(estadoAutenticador && estadoAutenticador.activo);

        return (
            <div>
                {errorAutenticador &&
                    <div className="text-danger mb-2">{errorAutenticador}</div>
                }
                {pasoAutenticador === null && this.renderEstadoAutenticador()}
                {pasoAutenticador === PASO_PASSWORD_REGISTRAR &&
                    <Fragment>
                        <small className="text-muted d-block mb-2">
                            Escriba su contraseña para confirmar que es usted quien
                            registra el autenticador.
                        </small>
                        {reemplazaUnoActivo &&
                            <small className="text-warning d-block mb-2">
                                <i className="fa fa-exclamation-triangle mr-1"></i>
                                Al continuar, el autenticador que tiene ahora deja de
                                funcionar, incluso si después cancela: se genera un
                                secreto nuevo y hay que confirmarlo con el primer
                                código. Hasta que lo confirme, va a poder iniciar
                                sesión solo con su contraseña.
                            </small>
                        }
                        {this.renderPasswordAutenticador(
                            "Continuar", () => this.registrarAutenticador()
                        )}
                    </Fragment>
                }
                {pasoAutenticador === PASO_ESCANEAR && this.renderEscanearAutenticador()}
                {pasoAutenticador === PASO_PASSWORD_QUITAR &&
                    <Fragment>
                        <small className="text-muted d-block mb-2">
                            Escriba su contraseña para quitar el autenticador. Después
                            de esto va a poder iniciar sesión solo con la contraseña.
                        </small>
                        {this.renderPasswordAutenticador(
                            "Quitar autenticador", () => this.quitarAutenticador()
                        )}
                    </Fragment>
                }
            </div>
        );
    }

    render() {
        return (
            <ParadigmaModal
                navButton={true}
                nav={({
                    name: 'Perfil',
                    icon: 'fa fa-user',
                    tag: 'button',
                    className: 'dropdown-item'
                })}

                // Solo getUrl: este modal LEE por el ParadigmaModal pero no
                // escribe por el. Sin submitUrl no hay submit del modal, y sin
                // saveButton ni closeButton no hay footer (ParadigmaModal no lo
                // dibuja vacio).
                //
                // El motivo es que el footer era del MODAL y no de la pestaña:
                // estando parado en Sesiones o en Autenticador seguia
                // ofreciendo Guardar y Cancelar, que no guardaban ni cancelaban
                // nada de lo que se estaba mirando. Ahora cada pestaña tiene sus
                // propios botones y hace su propio request — Sesiones y
                // Autenticador ya funcionaban asi, y Perfil se suma con
                // guardarPerfil().
                //
                // Para cerrar queda la X del encabezado.
                getUrl={api.usuarios.perfil}

                onOpen={() => (this.props.onOpen ? this.props.onOpen() : null)}
                onGotData={(data) => this.setData(data)}
                onClose={() => { (this.props.onClose ? this.props.onClose() : null); this.resetForm(); }}
                onCleanForm={() => this.resetForm()}

                title={"Editar Perfil"}

                saveButton={false}
                closeButton={false}

                // 'max-width-550' la define scss/_custom.scss de CADA frontend
                // (este archivo es el mismo en los dos). No se usa una clase de
                // Bootstrap porque 550px no es ninguno de sus tamaños: el
                // .modal-dialog mide 500 y .modal-lg 800, y el medio no existe.
                //
                // Va en el modal y no en una pestaña, asi que las tres miden lo
                // mismo: el ancho lo fija el .modal-dialog y no cambia al
                // cambiar de tab.
                //
                // 'modal-tabs' se mantiene aunque hoy no tenga ninguna regla
                // CSS asociada: es el gancho que comparte con el modal de
                // Usuarios y sacarlo seria un cambio aparte.
                className="modal-tabs max-width-550"
            >
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={(this.state.activeTab == TAB_PERFIL ? "active" : "")}
                            onClick={() => { this.setState({ activeTab: TAB_PERFIL }) }}
                        >Perfil</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={(this.state.activeTab == TAB_SESIONES ? "active" : "")}
                            onClick={() => { this.setState({ activeTab: TAB_SESIONES }) }}
                        >Sesiones</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={(this.state.activeTab == TAB_AUTENTICADOR ? "active" : "")}
                            onClick={() => { this.setState({ activeTab: TAB_AUTENTICADOR }) }}
                        >Autenticador</NavLink>
                    </NavItem>
                </Nav>
                {/* El 'px-3' de las tres pestañas devuelve el padding lateral
                    que les saca una regla global de scss/_custom.scss:

                        .modal-body .tab-content { margin-left: -1rem;
                                                   margin-right: -1rem; }

                    Ese margen negativo cancela el padding del .modal-body, asi
                    que sin el px-3 el contenido de las pestañas arranca pegado
                    al borde del modal. Peor: un <Row> adentro tiene su propio
                    margen de -15px, que esta pensado para absorberse contra el
                    padding del contenedor — sin padding que absorber, la fila se
                    va 15px AFUERA del modal, que es lo que hacia que el QR se
                    montara sobre el texto de al lado.

                    Va en las tres y no solo en Autenticador para que las
                    pestañas midan y se alineen igual entre si. */}
                <TabContent
                    activeTab={this.state.activeTab}
                    className={"py-2"}>
                    <TabPane tabId={TAB_PERFIL} className="py-0 px-3">
                        <ParadigmaLabeledInput
                            md={[2, 10]}
                            label={"Apellido"}
                            value={this.state.last_name}
                            onChange={(e) => {
                                let errors = this.state.errors;
                                if (errors) errors.last_name = null;
                                this.setState({ last_name: e.target.value, errors: errors, guardadoOk: false });
                            }}
                            error={(this.state.errors ? this.state.errors.last_name : null)}
                        />
                        <ParadigmaLabeledInput
                            md={[2, 10]}
                            label={"Nombre"}

                            value={this.state.first_name}
                            onChange={(e) => {
                                let errors = this.state.errors;
                                if (errors) errors.first_name = null;
                                this.setState({ first_name: e.target.value, errors: errors, guardadoOk: false });
                            }}
                            error={(this.state.errors ? this.state.errors.first_name : null)}
                        />
                        <ParadigmaLabeledInput
                            md={[2, 10]}
                            label={"Usuario"}
                            disabled={true}

                            value={this.state.username}
                            onChange={(e) => {
                                let errors = this.state.errors;
                                if (errors) errors.username = null;
                                this.setState({ username: e.target.value, errors: errors });
                            }}
                            error={(this.state.errors ? this.state.errors.username : null)}
                        />
                        <ParadigmaLabeledInput
                            md={[2, 10]}
                            label={"Email"}
                            disabled={true}

                            value={this.state.email}
                            onChange={(e) => {
                                let errors = this.state.errors;
                                if (errors) errors.email = null;
                                this.setState({ email: e.target.value, errors: errors });
                            }}
                            error={(this.state.errors ? this.state.errors.email : null)}
                        />
                        <Row className="mt-1">
                            <Col className="col-12 col-sm-6">
                                {/* El unico campo del sistema que pide la
                                    contraseña ACTUAL, de ahi el autoComplete
                                    propio: ParadigmaLabeledInput le pone
                                    'new-password' a todo campo de tipo password
                                    (bien para los otros dos de abajo, que son
                                    para escribir una nueva) y eso le impide al
                                    gestor de contraseñas completar este. */}
                                <ParadigmaLabeledInput
                                    label={"Contraseña actual"}
                                    type={"password"}
                                    autoComplete={"current-password"}

                                    value={this.state.passwordActual}
                                    onChange={(e) => {
                                        let errors = this.state.errors;
                                        if (errors) errors.password_actual = null;
                                        this.setState({ passwordActual: e.target.value, errors: errors, guardadoOk: false });
                                    }}
                                    error={(this.state.errors ? this.state.errors.password_actual : null)}
                                />
                            </Col>
                        </Row>
                        <Row className="mt-1">
                            <Col className="col-12 col-sm-6">
                                <ParadigmaLabeledInput
                                    label={"Contraseña nueva"}
                                    type={"password"}

                                    value={this.state.password}
                                    onChange={(e) => {
                                        let errors = this.state.errors;
                                        if (errors) errors.password = null;
                                        this.setState({ password: e.target.value, errors: errors, guardadoOk: false });
                                    }}
                                    error={(this.state.errors ? this.state.errors.password : null)}
                                />
                            </Col>
                            <Col className="col-12 col-sm-6">
                                <ParadigmaLabeledInput
                                    label={"Repetir contraseña nueva"}
                                    type={"password"}

                                    value={this.state.password2}
                                    onChange={(e) => {
                                        let errors = this.state.errors;
                                        if (errors) errors.password2 = null;
                                        this.setState({ password2: e.target.value, errors: errors, guardadoOk: false });
                                    }}
                                    error={(this.state.errors ? this.state.errors.password2 : null)}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col className="col-12">
                                <small className="text-muted d-block mt-1">
                                    Deje los campos vacíos para no cambiar la contraseña.
                                </small>
                                <small className="text-muted d-block">
                                    Al cambiar la contraseña se cierran las demás sesiones abiertas.
                                </small>
                                <PasswordPolicyHint password={this.state.password} />
                            </Col>
                        </Row>
                        {/* El boton de guardar vive aca adentro y no en un footer
                            del modal: guarda SOLO esta pestaña, y asi se ve de
                            que es. Sesiones y Autenticador tienen los suyos. */}
                        <Row className="mt-2">
                            <Col className="col-12">
                                {this.state.errorPerfil &&
                                    <div className="text-danger mb-2">{this.state.errorPerfil}</div>
                                }
                                {this.state.guardadoOk &&
                                    <div className="text-success mb-2">
                                        <i className="fa fa-check mr-1"></i>
                                        Los cambios fueron guardados.
                                    </div>
                                }
                                <Button
                                    color="success"
                                    disabled={this.state.guardandoPerfil}
                                    onClick={() => this.guardarPerfil()}
                                >
                                    {this.state.guardandoPerfil ? 'Guardando...' : 'Guardar cambios'}
                                </Button>
                            </Col>
                        </Row>
                    </TabPane>
                    <TabPane tabId={TAB_SESIONES} className="py-0 px-3">
                        {this.renderSesiones()}
                    </TabPane>
                    <TabPane tabId={TAB_AUTENTICADOR} className="py-0 px-3">
                        {this.renderAutenticador()}
                    </TabPane>
                </TabContent>
            </ParadigmaModal>
        );
    }
}

export default Perfil;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Usuarios/Perfil.js